import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface ApiErrorDialogData {
  title: string;
  message: string;
  actionText?: string;
  source?: string;
  category?: string;
  severity?: 'info' | 'warning' | 'error';
  retryable?: boolean;
  details?: string[];
  metaCode?: string | number | null;
  metaSubcode?: string | number | null;
  metaType?: string | null;
  fbtraceId?: string | null;
  closeText?: string;
}

@Component({
  selector: 'app-api-error-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './api-error-dialog.component.html',
  styleUrl: './api-error-dialog.component.scss'
})
export class ApiErrorDialogComponent {
  readonly closeText: string;

  constructor(
    public dialogRef: MatDialogRef<ApiErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApiErrorDialogData
  ) {
    this.closeText = data.closeText ?? 'Cerrar';
  }

  get sourceKey(): string {
    return (this.data.source || 'BACKEND').trim().toUpperCase();
  }

  get sourceLabel(): string {
    const source = this.sourceKey;
    if (source === 'INFO') {
      return 'Información';
    }
    if (source === 'META') {
      return 'WhatsApp';
    }
    if (source === 'BACKEND') {
      return 'Sistema';
    }
    return source || 'Sistema';
  }

  get contextLabel(): string {
    switch ((this.data.category || '').trim().toUpperCase()) {
      case 'CONVERSATION_BLOCKED': return 'Acción bloqueada';
      case 'CONVERSATION_CLOSED': return 'Conversación cerrada';
      case 'CUSTOMER_REPLY_REQUIRED': return 'Respuesta pendiente';
      case 'TEMPLATE_REQUIRED': return 'Paso requerido';
      case 'CONNECTION_ERROR': return 'Problema de conexión';
      case 'SERVICE_UNAVAILABLE': return 'Servicio no disponible';
      default: return this.sourceLabel;
    }
  }

  get tone(): 'info' | 'warning' | 'error' {
    return this.data.severity || (this.sourceKey === 'INFO' ? 'info' : 'error');
  }

  get iconClass(): string {
    if (this.tone === 'info') return 'bi-info-circle-fill';
    if (this.tone === 'warning') return 'bi-exclamation-triangle-fill';
    return 'bi-exclamation-circle-fill';
  }

  get technicalDetails(): string[] {
    const details = [...(this.data.details || [])];
    this.addDetail(details, 'Código de WhatsApp', this.data.metaCode);
    this.addDetail(details, 'Detalle de WhatsApp', this.data.metaSubcode);
    this.addDetail(details, 'Tipo de respuesta', this.data.metaType);
    this.addDetail(details, 'Identificador de seguimiento', this.data.fbtraceId);
    return details;
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  private addDetail(details: string[], label: string, value: string | number | null | undefined): void {
    if (value === null || value === undefined || String(value).trim() === '') {
      return;
    }
    details.push(`${label}: ${value}`);
  }
}
